import { Box, Modal, Typography } from "@mui/material";
import { useState } from "react";
import { useHistory, useParams } from "react-router";
import Formbody from "../Formbody";
import SectionImage from "./SectionImage";

const SectionImageAction = ({ course, image, mobileImage, alt }) => {
  const [open, setOpen] = useState(false);
  const { course_id } = useParams();
  const history = useHistory();

  const handleClick = () => {
    const inDateRange = course?.inDateRange;

    if (
      inDateRange === false ||
      inDateRange === 0 ||
      inDateRange === "0"
    ) {
      setOpen(true);
      return;
    }

    if (inDateRange === true || inDateRange === 1 || inDateRange === "1") {
      history.push(`/courses/payment/${course_id}`);
    }
  };

  return (
    <>
      <Modal open={open} onClose={() => setOpen(false)}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            maxWidth: "50rem",
            display: "flex",
            flexDirection: "column",
            bgcolor: "background.paper",
            borderRadius: "0.6rem",
            p: 4,
            width: "100%",
          }}
        >
          <Typography variant="h4" sx={{ textAlign: "center", color: "black" }}>
            Inscreva-se para receber novidades sobre este curso!
          </Typography>
          <Typography
            variant="h6"
            sx={{ mb: 4, mt: 2, textAlign: "center", color: "black" }}
          >
            Não vamos encher sua caixa de entrada com spam.
          </Typography>
          <Formbody course_id={course_id} />
        </Box>
      </Modal>

      <SectionImage
        image={image}
        mobileImage={mobileImage}
        alt={alt}
        onClick={handleClick}
      />
    </>
  );
};

export default SectionImageAction;
